import { Inertia } from "@inertiajs/inertia";
import { keys } from "lodash";

// initial state
const state = () => ({
  pagination: {
    currentPage: 1,
    perPage: 10,
    totalItems: 0,
    totalPages: 0,
  },
  isLoading: false,
  filtersApplied: false,
  selectedAP: [],
  selectedStatus: [],
  selectedTypes: [],
  status: [],
  selectedHeaders: [],
  tempBibles: [],
  newBible: null,
  searching: false,
  types: [],
  modes: ["Manual", "Automático"],
  academic_periods: [],
  strategies: [],
  filters: [], //todo: pasar los filtros con sus ids para mapearlos en el menu de filtros
  selectedFilters: [], // esto ya funciona pero es probable que haya que cambiarlo al cambiar como funciona el biblesay de filtros del que se llena
  bibles: null,
  search: "",
  bible: {},
  tableHeaders: [],
  bibleDetails: [],
  bibleEditInfo: null,
  genDial: null,
  searchingText: null,
  itemsWithError: 0,
  rules: {
    requiredName: (value) => !!value || "Es necesario añadir un nombre.",
    requiredEmail: (value) => !!value || "Es necesario añadir un email.",
    requiredPass: (value) =>
      !!value || "Es necesario añadir una contraseña.",
    email: (value) => {
      const pattern =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return pattern.test(value) || "El email no es válido.";
    },
  },
})

// getters
const getters = {
  hasErrors(state) {
    return state.itemsWithError > 0;
  },
  getRules(state) {
    return state.rules
  },
  getNoResultsText(state) {

    if (state.searching) {
      return {
        subtitle: "No se encontraron resultados para: ",
        search: state.searchingText
      };
    }
    else if (state.selectedAP.length > 0 || state.selectedTypes.length > 0 || state.selectedStatus.length > 0) {
      return {
        subtitle: "No se han encontrado biblias para los filtros seleccionados.",
        search: null
      }
    }
    else if (!state.searching) {
      return {
        subtitle: "¡Todavía no se han creado biblias!",
        search: null
      }
    }
    else {
      return {
        subtitle: "No hay nada que mostrar.",
        search: null
      }
    }
  },
  getGenDial(state) {
    return state.genDial
  },
  getPagination(state) {
    return state.pagination;
  },
  getIsLoading(state) {
    return state.isLoading;
  },
  getAllHeaders: (state) => {
    return JSON.parse(JSON.stringify(state.selectedHeaders));
  },
  areFiltersApplied: (state) => {
    return state.filtersApplied;
  },
  getBibleDetails: (state) => {
    return state.bibleDetails;
  },
  filteredBibles: (state) => (bibles) => {
    return bibles.filter((bible) => {
      if (state.selectedAP.length > 0) {
        return state.selectedAP.includes(bible.academic_period_id);
      }
      return true;
    }).filter((bible) => {
      if (state.selectedTypes.length > 0) {
        return state.selectedTypes.includes(bible.type_id);
      }
      return true;
    }
    ).filter((bible) => {
      if (state.selectedStatus.length > 0) {
        return state.selectedStatus.includes(bible.status);
      }
      return true;
    });
  },
  getSelectedAP: (state) => {
    return state.selectedAP;
  },
  getSelectedTypes: (state) => {
    return state.selectedTypes;
  },
  getSelectedStatus: (state) => {
    return state.selectedStatus;
  },
  getBibles: (state, getters) => {
    if (!state.searching)
      return state.bibles.map(bible => {
        return {
          ...bible,
          academic_period: getters.getAcademicPeriodById(bible.academic_period_id),
          type: getters.getTypeById(bible.type_id),
          status: getters.getStatusById(bible.status_id),
          version: getters.getStrategyById(bible.strategy_id)
        }
      })
    else
      return state.tempBibles.map(bible => {
        return {
          ...bible,
          academic_period: getters.getAcademicPeriodById(bible.academic_period_id),
          type: getters.getTypeById(bible.type_id),
          status: getters.getStatusById(bible.status_id),
          version: getters.getStrategyById(bible.strategy_id)
        }
      })
  },
  getASingleBible(state, getters) {
    const bible = state.bible;
    return {
      ...bible,
      academic_period: getters.getAcademicPeriodById(bible.academic_period_id),
      type: getters.getTypeById(bible.type_id),
      status: getters.getStatusById(bible.status_id),
      version: getters.getStrategyById(bible.strategy_id)
    };
  },
  getHeadersBibleDetails(state) {
    if (!state.bibleDetails[0])
      return
    const headers = state.tableHeaders.filter(header => header.val).map(header => {
      return {
        align: 'center',
        text: header.name,
        value: header.name,
        sortable: true
      }
    })
    //implement together with the warnings section in the Table Component
    /*headers.push({
      value: 'warnings',
      sortable: false
    })*/
    headers.push({
      value: 'actions',
      sortable: false
    })
    headers.push({
      value: 'data-table-expand',
      sortable: false
    })
    return headers;
  },
  getFilters(state) {
    return state.filters;
  },
  getNumberOfErrors: (state) => {
    return state.itemsWithError;
  },
  getAcademicPeriods: (state) => {
    return state.academic_periods.map(a => {
      return { uuid: a.uuid, name: a.name }
    })
  },
  getStrategies: (state) => {
    return state.strategies.map(a => {
      return { uuid: a.uuid, name: a.name }
    })
  },
  getTypesBible: (state) => {
    return state.types.map(a => {
      return { uuid: a.uuid, name: a.name }
    })
  },
  getSelectedFilters(state) {
    return state.selectedFilters;
  },
  getAcademicPeriodById: (state) => (uuid) => {
    const academic_period = state.academic_periods.find(ap => ap.uuid === uuid);
    return academic_period ? academic_period.name : "Sin especificar"
  },
  getTypeById: (state) => (uuid) => {
    const type = state.types.find(t => t.uuid === uuid)
    return type ? type.name : "Sin especificar";
  },
  getStrategyById: (state) => (uuid) => {
    const strategy = state.strategies.find(st => st.uuid === uuid);
    return strategy ? strategy.name : "Sin especificar"
  },

  contain: (state, getters) => (bible, searchingText) => {
    const included_in_name = bible.name.toLowerCase().includes(searchingText);
    const included_in_status = getters.getStatusById(bible.status_id).toLowerCase().includes(searchingText);
    const included_in_type = getters.getTypeById(bible.type_id).toLowerCase().includes(searchingText);
    const included_in_strategy = getters.getStrategyById(bible.strategy_id).toLowerCase().includes(searchingText);
    return (included_in_name || included_in_status || included_in_type || included_in_strategy)
  },
  getModes: (state) => {
    return state.modes;
  },
  getStatus: (state) => {
    return state.status.map(status => {
      return { id: status.uuid, name: status.name, disabled: status.name === 'En construcción' };
    });
  },
  getStatusById: (state) => (uuid) => {
    const status = state.status.find(st => st.uuid === uuid);
    return status ? status.name : "Sin especificar"
  },
}
// actions
const actions = {
  uploadBasic({state,commit}){
    Inertia.get('/drive-upload-bible',{uuid:state.bible.uuid,pagination: state.pagination}, {
      preserveScroll: true,
      preserveState: false,
      onFinish: visit => {
        Inertia.visit(location.pathname, {
          preserveState: false,
          preserveScroll: true,
          data:{
            uuid:state.bible.uuid,
            pagination: state.pagination
          }
        })
      },
      onSuccess: visit => {
        commit('setNotification', {
          title: visit.props.flash.response === 'success'?"¡Exportación exitosa!":'¡Exportación fallida!',
          msg: visit.props.flash.response === 'success'?`La Biblia ${state.bible.name} se ha exportado a Drive correctamente.`:visit.props.flash.response,
          filled: true,
          success: visit.props.flash.response === 'success',
          error: visit.props.flash.response !== 'success',
          active: true,
        },{root: true});
        setTimeout(() => dispatch('closeNotification',{}, {root: true}), 5000);
      },
    })
      
  },
  setAllStatus({ commit }, status) {
    commit("setAllStatus", status);
  },
  setNumberOfErrors({ commit }, itemsWithError) {
    commit('setNumberOfErrors', itemsWithError);
  },
  setSearch({ commit }, search) {
    commit("setSearch", search);
  },
  setPagination({ commit }, pagination) {
    commit('setPagination', pagination);
  },
  serachItem({ state, commit }, text) {
    if (text === "" || text === /\s/ || !text) return;
    commit('setPagination', {
      currentPage: 1,
      perPage: 10,
      totalItems: 0,
      totalPages: 0
    });
    localStorage.setItem('searching', text);
    const columns = state.tableHeaders.filter(header => header.val).map(header => header.name);
    Inertia.get('/bible-item-serach', { data: columns, uuid: state.bible.uuid, text: localStorage.searching, pagination: state.pagination}, {
      preserveScroll: true,
      preserveState: false,
      onFinish: visit => {
        Inertia.visit(location.pathname, {
          preserveState: false,
          preserveScroll: true,
          data: {
            uuid: state.bible.uuid,
            data: columns,
            text: localStorage.searching,
            pagination: state.pagination
          }
        });
      },
      onSuccess: visit => {

      },
    })
  },
  changeLoadingState({ commit }, newState) {
    commit('setIsLoading', newState)
  },
  editBibleItem({ state, commit, dispatch }, newItem) {
    commit('setIsLoading', true);
    const oldValue = state.bibleDetails.find(item => item._id === newItem._id);
    const changes = {};
    keys(newItem).forEach((key) => {
      if (newItem[key] !== oldValue[key])
        changes[key] = newItem[key]
    });
    Inertia.put('/bible-item', { data: changes, _id: newItem._id, uuid: state.bible.uuid, pagination: state.pagination }, {
      onFinish: visit => {
        Inertia.visit(location.pathname, {
          preserveState: false,
          preserveScroll: true,
          data: {
            uuid: state.bible.uuid,
            pagination: state.pagination
          }
        });
      },
      onSuccess: visit => {
        // to-do -> poner notificacion
        commit('setNotification', {
          title: "¡Edición exitosa!",
          msg: "Se ha editado la fila seleccionada",
          filled: true,
          success: true,
          active: true,
          pagination: state.pagination,
        }, {root: true});
        setTimeout(() => dispatch('closeNotification',{}, {root: true}), 5000);
        commit('setIsLoading', false);
      },
    })
  },
  replaceBibleFile({ state, commit, dispatch }, newBible) {
    commit('setIsLoading', true);
    localStorage.setItem("current_page", 1)
    commit('setPagination', {
      currentPage: 1,
      perPage: 10,
      totalItems: 0,
      totalPages: 0
    });
    const _path = location.pathname;
    commit("setNewBible", newBible);
    Inertia.post('/replace-bible', { bible: { ...newBible }, pagination: _path === '/' ? {} : state.pagination, home: _path === '/' ? true : false }, {
      onFinish: visit => {
        Inertia.visit(location.pathname, {
          preserveState: false,
          preserveScroll: true,
          data: {
            uuid: state.bible.uuid,
            pagination: _path !== '/' ? state.pagination : {}
          }
        });
      },
      onSuccess: visit => {
        // to-do -> poner notificacion
        commit('setNotification', {
          title: "Reemplazo exitoso!",
          msg: `${newBible.name} se esta construyendo. Se notificará cuando esté lista.`,
          filled: true,
          success: true,
          active: true,
        }, {root: true});
        setTimeout(() => dispatch('closeNotification',{}, {root: true}), 5000);
        commit("setGenDial", false);
        commit('setIsLoading', false);
      },
    });
  },
  changeSelectionHeaders({ commit }, selected) {
    commit('setSelectedHeaders', selected)
  },
  cancelSelectionHeaders({ state, commit }) {
    commit('setSelectedHeaders', state.tableHeaders)
  },
  deleteBible({ commit, dispatch }, { uuid, name }) {
    commit('setIsLoading', true)
    Inertia.post('/delete-bible', { uuid: uuid }, {
      preserveState: false,
      preserveScroll: true,
      onFinish: visit => {
        Inertia.visit(location.pathname);
      },
      onSuccess: visit => {
        // to-do -> poner notificacion
        commit('setNotification', {
          title: visit.props.flash.response === 'success'?"¡Eliminación exitosa!":'¡Eliminación fallida!',
          msg: visit.props.flash.response === 'success'?`La Biblia ${name} se ha eliminado correctamente.`:'Ha ocurrido un error.',
          filled: true,
          success: visit.props.flash.response === 'success',
          error: visit.props.flash.response !== 'success',
          active: true,
        }, {root: true});
        setTimeout(() => dispatch('closeNotification',{}, {root: true}), 5000);
        commit('setIsLoading', false)
      },
    })
  },
  deleteBibleItem({ state, commit, dispatch }, id) {
    commit('setIsLoading', true);
    Inertia.post('/delete-bible-item', { uuid: state.bible.uuid, id: id, pagination: state.pagination }, {
      onFinish: visit => {
        Inertia.visit(location.pathname, {
          preserveState: false,
          preserveScroll: true,
          data: {
            uuid: state.bible.uuid,
            pagination: state.pagination
          }
        });
      },
      onSuccess: visit => {
        // to-do -> poner notificacion
        commit('setNotification', {
          title: "¡Eliminación exitosa!",
          msg: `La fila se ha eliminado correctamente.`,
          filled: true,
          success: true,
          active: true,
        }, {root: true});
        setTimeout(() => dispatch('closeNotification',{}, {root: true}), 5000);
        commit('setIsLoading', false)
      },
    })
  },
  downloadBible({ }, path) {
    window.open(
      path,
      '_blank' // <- This is what makes it open in a new window.
    );
  },
  setBibleDetails({ commit }, bibleDetails) {
    commit('setBibleDetails', bibleDetails);
    if (bibleDetails.length <= 0) return;
    const headers = [];
    Object.keys(bibleDetails[0]).forEach((key, index) => {
      if (key !== "_id" && key !== "updated_at" && key !== "created_at" && key !== "error")
        headers.push({
          name: key,
          val: (index < 5),
        });
    })
    if (localStorage.columns)
      commit('setSelectedHeaders', JSON.parse(localStorage.columns));
    else
      commit('setSelectedHeaders', headers);
  },
  setAllBibles({ commit }, payload) {
    commit('setBibles', payload)
  },
  setAllTypes({ commit }, payload) {
    commit('setTypes', payload)
  },
  setAllAcademicPeriods({ commit }, payload) {
    commit('setAcademiperiods', payload)
  },
  setAllStrategies({ commit }, payload) {
    commit('setStrategies', payload)
  },
  searchBibles: ({ state, commit, getters }, searchingText) => {
    const validation = searchingText.length === 0
    commit('setSearching', validation ? false : true)
    commit('setSearchingText', searchingText)
    if (!validation) {
      const temp = state.bibles.filter(bible => {
        const result = getters.contain(bible, searchingText.toLowerCase())
        return result;
      })
      commit('setTempBible', temp)
    }
  },
  setNewBible({ commit, dispatch }, newBible) {
    commit('setIsLoading', true);
    commit("setNewBible", newBible);
    Inertia.post('/bible', { code: '1234567', ...newBible }, {
      onFinish: visit => {
        Inertia.visit(location.pathname);
      },
      onSuccess: visit => {
        // to-do -> poner notificacion
        commit('setNotification', {
          title: `${visit.props.flash.response === 'success' ? '¡Creación exitosa!' : '¡Creación fallida!'}`,
          msg: visit.props.flash.response === 'success' ? `La Biblia ${newBible.name} se ha creado correctamente.`: visit.props.flash.response,
          filled: true,
          success: visit.props.flash.response === 'success' ? true : false,
          error: visit.props.flash.response === 'success' ? false : true,
          active: true,
        }, {root: true});
        setTimeout(() => dispatch('closeNotification',{}, {root: true}), 5000);
        commit("setGenDial", false);
        commit('setIsLoading', false);
      },
    });
    //commit('setIsLoading', false);
  },
  loginWithGoogle() {
    Inertia.get('/auth/google-code', {
      preserveState: false,
      preserveScroll: true,
      onFinish: visit => {
        /* Inertia.visit(location.pathname,{
          preserveState: false,
          preserveScroll: true, 
        }); */
      },
      onSuccess: visit => {
        // to-do -> poner notificacion
      },
    });
  },
  editBible({ commit, dispatch }, payload) {
    commit('setIsLoading', true)
    commit('setBibleEditInfo', payload)
    Inertia.put('/bible', payload, {
      preserveState: false,
      preserveScroll: true,
      onFinish: visit => {
        Inertia.visit(location.pathname);
      },
      onSuccess: visit => {
        // to-do -> poner notificacion
        commit('setNotification', {
          title: visit.props.flash.response === 'success'?"¡Edición exitosa!":"¡Edición fallida!",
          msg: visit.props.flash.response === 'success'?`La Biblia ${payload.data.name} se ha editado correctamente.`:'Ha ocurrido un error',
          filled: true,
          success: visit.props.flash.response === 'success',
          error: visit.props.flash.response !== 'success',
          active: true,
        }, {root: true});
        setTimeout(() => dispatch('closeNotification',{}, {root: true}), 5000);
        commit('setIsLoading', false);
      },
    });
  },
  bibleDetail({ state }, uuid) {
    const columns = state.tableHeaders.filter(header => header.val).map(header => header.name);
    const data = {
      uuid,
      pagination: state.pagination
    }
    if (localStorage.searching){
      data.text = localStorage.searching;
      data.data = columns;
    }

    Inertia.get("/detail", data, {
      preserveState: false,
      preserveScroll: true,
    });
  },
  setASingleBible({ commit }, bible) {
    commit('setASingleBible', bible);
  }
}

// mutations
const mutations = {
  setNumberOfErrors(state, itemsWithError) {
    state.itemsWithError = itemsWithError;
  },
  setSearch(state, search) {
    state.search = search;
  },
  setAllStatus(state, status) {
    state.status = status;
  },
  setGenDial(state, payload) {
    state.genDial = payload;
  },
  setSearchingText(state, payload) {
    state.searchingText = payload;
  },
  setPagination: (state, pagination) => {
    state.pagination = pagination;
  },
  setIsLoading: (state, newValue) => {
    state.isLoading = newValue;
  },
  setSelectedHeaders: (state, selected) => {
    state.tableHeaders = JSON.parse(JSON.stringify(selected));
    state.selectedHeaders = selected;
  },
  setBibleDetails: (state, bibleDetails) => {
    state.bibleDetails = bibleDetails
  },
  setASingleBible: (state, bible) => {
    state.bible = bible;
  },
  setNewBible: (state, newBible) => {
    state.newBible = newBible;
  },
  setFiltersApplied: (state, payload) => {
    state.filtersApplied = payload;
  },
  setSelectedAP: (state, payload) => {
    state.selectedAP = payload;
  },
  setSelectedTypes: (state, payload) => {
    state.selectedTypes = payload;
  },
  setSelectedStatus: (state, payload) => {
    state.selectedStatus = payload;
  },
  setSearching: (state, payload) => {
    state.searching = payload;
  },
  setTempBible: (state, payload) => {
    state.tempBibles = payload;
  },
  setFilters(state, filters) {
    state.filters = filters
  },
  setSelectedFilters(state, payload) {
    state.selectedFilters = payload
  },
  setBibles(state, bibles) {
    state.bibles = bibles
  },
  setTypes(state, types) {
    state.types = types
  },
  setAcademiperiods(state, academicPeriods) {
    state.academic_periods = academicPeriods
  },
  setStrategies(state, strategies) {
    state.strategies = strategies
  },
  setBibleEditInfo(state, bibleEditInfo) {
    state.bibleEditInfo = bibleEditInfo
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
